<template>
  <BaseCard>
    <BaseCardHeader> Permissions </BaseCardHeader>
    <BaseCardBody>
      <PermissionsManager :role-id="role.id" can-edit />
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import { entityComputed } from '@/store/helper';
import PermissionsManager from './PermissionsManager.vue';

const ENTITY_PERMISSIONS = 'permissions';

export default {
  components: { PermissionsManager },
  props: {
    role: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...entityComputed,
    permissions() {
      if (!this.role.permissions) {
        return [];
      }

      return this.role.permissions.map((permission) =>
        this.entityById(ENTITY_PERMISSIONS, permission)
      );
    },
  },
};
</script>
